// src/components/EntitlementMask.tsx
import { Button } from "@/components/ui/button";
import { usePricingModal } from "@/context/PricingModalContext";

export function EntitlementMask() {
  const { openPricingModal } = usePricingModal?.() ?? { openPricingModal: () => {} };

  return (
    <div className="absolute inset-0 z-30 flex items-end sm:items-center justify-center">
      <div className="pointer-events-none absolute inset-0 rounded-2xl bg-gradient-to-t from-black/55 via-black/20 to-transparent" />
      {/* <div className="relative mb-3 sm:mb-0">
        <Button
          size="sm"
          onClick={(e) => { e.stopPropagation(); openPricingModal?.(); }}
          className="shadow-lg"
        >
          Unlock all ads
        </Button>
      </div> */}
    </div>
  );
}
